import { render } from "./CaseGrid.vue?vue&type=template&id=500215a3"
import script from "./CaseGrid.vue?vue&type=script&lang=js"
export * from "./CaseGrid.vue?vue&type=script&lang=js"

import "./CaseGrid.vue?vue&type=style&index=0&id=500215a3&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__